export default "__VITE_ASSET__DatEycei__"